import type { Driver, LapRef, Session, SessionSummary } from '@tla/types';
import { formatLapTime } from './format';

/**
 * Human-readable descriptor for a lap reference, e.g. "JJ · S1 · L7 · 1:15.225".
 * Used for graph legends and other places that need the full lap identity
 * rather than just a lap number.
 */
export function lapDescriptor(
  ref: LapRef,
  sessions: Record<string, Session>,
  drivers: Record<string, Driver>,
  summaries: Record<string, SessionSummary>,
): string {
  const session = sessions[ref.sessionId];
  const driver = session ? (drivers[session.driverId]?.name ?? 'Driver') : 'Driver';
  const stint = session?.stint;
  const lapTime = summaries[ref.sessionId]?.laps.find((l) => l.number === ref.lapNumber)?.lapTime;
  const stintPart = stint ? `S${stint} · ` : '';
  return `${driver} · ${stintPart}L${ref.lapNumber} · ${formatLapTime(lapTime)}`;
}
